var styleDataHash = "676f12b0";
const injectCss = () => {
  var css = `.uqP1g{display:flex}[dir] .uqP1g{margin:0}.in2XN{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));font-size:inherit;font-weight:inherit;line-height:28px;max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}[dir] .in2XN{margin:0;padding:0 4px}.in2XN:hover{text-decoration:underline}.in2XN:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.in2XN.UbNte{line-height:32px}[dir] .uJWq7{background:transparent;border:0}[dir] .uJWq7:hover{cursor:pointer}@supports not (contain:inline-size){@media only screen and (max-width:640px){.in2XN{max-width:160px}}}@container (width < 640px){.in2XN{max-width:160px}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var url_link_button_default = {
  "toolbarUrlContainer": "uqP1g",
  "toolbarUrl": "in2XN",
  "isMobile": "UbNte",
  "toolbarUrlAnchor": "uJWq7"
};
export {
  url_link_button_default as default,
  injectCss
};
//# sourceMappingURL=url-link-button-scss.js.map
